import { Component, ViewEncapsulation } from '@angular/core';
import { FormComponent } from '../../form/form.component';

@Component({
  selector: 'c16',
  templateUrl: './c16.component.html',
  styleUrls: ['./c16.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class C16Component extends FormComponent {}



// WEBPACK FOOTER //
// ./src/app/client/c16/c16.component.ts